import { useUserStore } from '@/stores/user'
import { cn } from '@/utils/style'

interface SegmentedProgressProps {
  value: number
  secondValue?: number
  className?: string
}

export function SegmentedProgressBar({
  value,
  secondValue = 0,
  className,
}: SegmentedProgressProps) {
  const userStore = useUserStore()

  const total = 1
  const segment1Width = (value / total) * 100
  const segment2Width = secondValue > value ? ((secondValue - value) / total) * 100 : 0
  const segment3Width = 100 - segment1Width - segment2Width

  const isExpired = userStore.order?.deadlineTime?.seconds * 1000 < new Date().getTime()

  return (
    <div className={cn('w-full h-6 rounded overflow-hidden gap-1 flex', className)}>
      {segment1Width > 0 && (
        <div
          className={cn(' h-full  rounded', isExpired ? 'bg-bar-tertiary' : 'bg-btn-tertiary')}
          style={{ width: `${segment1Width}%` }}
        />
      )}
      {segment2Width > 0 && (
        <div
          className={cn(' h-full rounded', isExpired ? 'bg-bar-tertiary/60' : 'bg-btn-secondary')}
          style={{ width: `${segment2Width}%` }}
        />
      )}
      {segment3Width > 0 && (
        <div
          className={cn('h-full bg-panel-gray-200 rounded')}
          style={{ width: `${segment3Width}%` }}
        />
      )}
    </div>
  )
}
